var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressParent"},[_c('div',{staticClass:"out-progress"},[_c('div',{staticClass:"progress"},[_c('span',{staticClass:"progress-item1",style:({ width: _vm.orderFinishCount() })})]),_c('div',{staticClass:"progress-item2"},[_vm._v(_vm._s(_vm.orderFinishCount()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }